import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { getFollowRequestStatus } from '../../lib/follow';
import { useNavigate } from 'react-router-dom';

interface MessageButtonProps {
  userId: string;
  username: string;
}

export function MessageButton({ userId, username }: MessageButtonProps) {
  const [isFriend, setIsFriend] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkFriendStatus();
  }, [userId]);

  const checkFriendStatus = async () => {
    const status = await getFollowRequestStatus(userId);
    setIsFriend(status === 'accepted');
  };

  const handleClick = () => {
    if (isFriend) {
      navigate(`/app/profile/messages/${username}`);
    } else {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={!isFriend}
      className={`px-4 py-2 rounded-full font-medium flex items-center gap-2 ${
        isFriend 
          ? 'bg-accent-primary hover:bg-accent-hover text-white cursor-pointer' 
          : 'bg-background-secondary text-text-secondary opacity-50 cursor-not-allowed'
      }`}
    >
      <MessageSquare size={18} />
      Nachricht
    </button>
  );
}